import { StateData } from 'src/types'

export const isStateEmpty = (states: StateData<unknown>[]): boolean =>
  states.find(
    ({ data, error }) => data === undefined && error === undefined
  ) !== undefined

export const filterStateErrors = (states: StateData<unknown>[]) =>
  states.filter(({ data, error }) => data === undefined && error !== undefined)
